import { render } from "./SellerPayment.vue?vue&type=template&id=0f4a22e6&scoped=true"
import script from "./SellerPayment.vue?vue&type=script&lang=js"
export * from "./SellerPayment.vue?vue&type=script&lang=js"

import "./SellerPayment.vue?vue&type=style&index=0&id=0f4a22e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4a22e6"]])

export default __exports__